import { Tag } from "antd";

function DeletedSubmittalTag() {
  return (
    <Tag className="text-black text-opacity-50 bg-ciq-blue-50 font-bold text-xs border-none px-2 py-1 rounded flex items-center justify-center w-full">
      Deleted
    </Tag>
  );
}

export default DeletedSubmittalTag;
